
import axios from 'axios';

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api').replace(/\/+$/, '');

const normalizeMediaUrl = (url) => {
  if (!url || typeof url !== 'string') return url;
  if (typeof window === 'undefined') return url;
  
  // If it's a base64 string, return as is
  if (url.startsWith('data:')) return url;
  
  // If it's a relative path, prepend API base URL
  let finalUrl = url;
  if (url.startsWith('/uploads/') || url.startsWith('uploads/')) {
    const relativePath = url.startsWith('/') ? url : `/${url}`;
    finalUrl = `${API_BASE_URL.replace('/api', '')}${relativePath}`;
  }

  try {
    const current = window.location;
    const parsed = new URL(finalUrl, current.origin);
    
    // Only force protocol for http/https URLs, not for data: or others
    if (parsed.protocol.startsWith('http') && parsed.protocol !== current.protocol) {
      parsed.protocol = current.protocol;
      return parsed.toString();
    }
    return parsed.toString();
  } catch (e) {
    // Fallback for non-URL strings or failed parsing
    return finalUrl;
  }
};

export const getGalleryItems = async () => {
  const res = await axios.get(`${API_BASE_URL}/gallery`);
  const items = Array.isArray(res.data) ? res.data : [];
  return items.map(item => ({
    ...item,
    img: normalizeMediaUrl(item.img)
  }));
};

export const saveGalleryItem = async (item) => {
  const newItem = {
    ...item
  };

  if (newItem.id) {
    await axios.put(`${API_BASE_URL}/gallery/${newItem.id}`, newItem);
  } else {
    const res = await axios.post(`${API_BASE_URL}/gallery`, newItem);
    if (res.data && res.data.id) {
      newItem.id = res.data.id;
    }
  }

  const all = await getGalleryItems();
  return all;
};

export const deleteGalleryItem = async (id) => {
  await axios.delete(`${API_BASE_URL}/gallery/${id}`);
  const all = await getGalleryItems();
  return all;
};
